import React from 'react'
import { RequireAuth } from './RequireAuth'
import { Home } from './pages/Home'
import { Layout } from './components/Layout'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import { type MyTmpVpnClient } from '@mytmpvpn/mytmpvpn-client'
import { ErrorProvider } from './ErrorContext'
// NotFound is imported statically (not lazy) so the catch-all route renders
// without needing a Suspense boundary at the Routes level.
import { NotFound } from './components/static/NotFound'

// Lazy-loaded pages — only loaded when navigated to
const Login = React.lazy(() => import('./auth/Login').then(m => ({ default: m.Login })))
const PasswordChange = React.lazy(() => import('./auth/PasswordChange').then(m => ({ default: m.PasswordChange })))
const Unregister = React.lazy(() => import('./auth/Unregister').then(m => ({ default: m.Unregister })))
const Pricing = React.lazy(() => import('./pages/Pricing'))
const Referral = React.lazy(() => import('./pages/Referral').then(m => ({ default: m.Referral })))
const Connect = React.lazy(() => import('./pages/Connect').then(m => ({ default: m.Connect })))
const PrivacyPolicy = React.lazy(() => import('./components/static/PrivacyPolicy'))
const TermsOfUse = React.lazy(() => import('./components/static/TermsOfUse'))
const ContactUs = React.lazy(() => import('./components/static/ContactUs'))
const Doc = React.lazy(() => import('./components/static/Doc'))
const DocCli = React.lazy(() => import('./components/static/DocCli'))
const Support = React.lazy(() => import('./components/static/Support'))
const Faq = React.lazy(() => import('./components/static/Faq'))
const Contribute = React.lazy(() => import('./components/static/Contribute'))
const MakeMoney = React.lazy(() => import('./components/static/MakeMoney'))
const Issue = React.lazy(() => import('./components/static/Issue').then(m => ({ default: m.Issue })))
const ReferralTermsPage = React.lazy(() => import('./components/static/ReferralTerms'))

export function MyRoutes({ client }: { client: MyTmpVpnClient }) {
  
  return (
    <BrowserRouter>
      <ErrorProvider>
        <Routes>
          <Route path='*' element={<NotFound />} />
          <Route path="/" element={<Layout />}>
            {/* Header  */}
            <Route path="/pricing" element={<Pricing client={client} />} />
            <Route path="/contribute" element={<Contribute />} />
            <Route path="/makemoney" element={<MakeMoney />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/doc" element={<Doc />} />
            <Route path="/doc-cli" element={<DocCli />} />
            <Route path="/issue" element={<Issue />} />
            <Route path="/support" element={<Support />} />
            <Route path="/password" element={
              <RequireAuth>
                <PasswordChange />
              </RequireAuth>
            } />
            <Route path="/unregister" element={
              <RequireAuth>
                <Unregister client={client} />
              </RequireAuth>
            } />
            <Route path="/referral" element={
              <RequireAuth>
                <Referral client={client} />
              </RequireAuth>
            } />
            <Route path="/connect/:vpnId" element={
              <RequireAuth>
                <Connect client={client} />
              </RequireAuth>
            } />
            <Route path="/login" element={<Login client={client} initialState='signIn' />} />
            <Route path="/signup" element={<Login client={client} initialState='signUp' />} />
            {/* Main content */}
            <Route index element={<Home client={client} />} />
            {/* Footer  */}
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/referral/terms" element={<ReferralTermsPage />} />
          </Route>
        </Routes>
      </ErrorProvider>
    </BrowserRouter >
  )
}
